/* eslint-disable func-names */
function Dictionary() {
    this._dictionary = {};
}

Dictionary.prototype.get = function (key) {
    return this._dictionary[key];
};
Dictionary.prototype.clear = function () {
    this._dictionary = {};
};
Dictionary.prototype.add = function (key, value) {
    this._dictionary[key] = value;
};

module.exports = Dictionary;



// WEBPACK FOOTER //
// ./src/components/vue-ctrls/dictionary.js